import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BodySpecialAccordionContentListItem from './StyledBodySpecialAccordionContentListItem';

function BodySpecialAccordionContentListToolbarItem({className, showBorder, children}) {
	let render = null;

	if (children) {
		render = React.Children.map(children, (child) => (
			<section className="accordion-item-toolbar-item">{child}</section>
		));
	}

	return (
		<StyledBodySpecialAccordionContentListToolbarItem className={className} showBorder={showBorder}>
			{render}
		</StyledBodySpecialAccordionContentListToolbarItem>
	);
}

BodySpecialAccordionContentListToolbarItem.propTypes = {
	className: PropTypes.string,
	showBorder: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
};

BodySpecialAccordionContentListToolbarItem.defaultProps = {
	showBorder: true
};

export default BodySpecialAccordionContentListToolbarItem;

export const StyledBodySpecialAccordionContentListToolbarItem = styled(BodySpecialAccordionContentListItem)`
	justify-content: flex-start;
	border-bottom: ${(props) => (props.showBorder ? 'var(--px-1) solid ' + 'var(--neutrals-200)' : 'none')};
	&:last-child {
		border-bottom: ${(props) => (props.showBorder ? 'var(--px-1) solid ' + 'var(--neutrals-200)' : 'none')};
	}
	.accordion-item-toolbar-item {
		height: var(--px-25);
		display: flex;
		align-items: center;
		width: auto;
		margin-left: var(--px-10);
		margin-right: var(--px-10);
		/* Remove extra margins from first and last item */
		&:first-child {
			margin-left: unset;
		}
		&:last-child {
			margin-right: unset;
		}
	}
`;
